/**
 * Templates (precedents) query-key factory.
 *
 * Namespace `['templates','documents',...]` per the FE technical spec for the
 * precedents-management workspace. Vale standards and firm-owned forks live in
 * the same list (discriminated by `origin: 'firm' | 'system'`); virtual Vale
 * entries have `id: null`, so versions/history keys only ever bind to
 * firm-owned numeric ids.
 */

import type { DocumentType } from '@/lib/services/templates/types';

export const templateKeys = {
  all: ['templates', 'documents'] as const,

  /** Active firm templates + virtual Vale standards (union list). */
  list: () => [...templateKeys.all, 'list'] as const,

  /** Archived firm templates only — Vale standards are never archived. */
  archived: () => [...templateKeys.all, 'archived'] as const,

  // No `detail` key — there is no `GET /templates/documents/:id` endpoint.
  // The drawer reads from the cached list entry (FE spec v1.1).

  /** Versions for a firm template. */
  versions: (id: number) => [...templateKeys.all, 'versions', id] as const,

  /** History (metadata audit log) for a firm template. */
  history: (id: number) => [...templateKeys.all, 'history', id] as const,

  /** Merge-field registry per document type (drives upload-drawer reference
   *  panel + detail-overview field card). */
  mergeFields: (documentType: DocumentType) =>
    [...templateKeys.all, 'merge-fields', documentType] as const
} as const;
